module.exports = __webpack_public_path__ + "img/bsre.aa4caa4d.png";